import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Clear from '@mui/icons-material/Clear';
import Warning from '@mui/icons-material/Warning';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ICircleStoreModel, removePlace, selectPlaces } from '@/editor/store/reducers/adSet-step.slice';
import { useAppDispatch, useAppSelector } from '@/store/hooks/redux';
import { mapService } from '@/editor/components/googleMaps/google-map-service';

export const LocationChips: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const places = useAppSelector(selectPlaces);

  const handleDelete = (el: ICircleStoreModel, index: number) => {
    dispatch(removePlace(index));
    mapService.removeCircle(el.address);
  };

  const handleClick = (el: ICircleStoreModel) => {
    mapService.panToLocation(el.center.lat, el.center.lng);
  };

  return (
    <Box component="div" sx={{ width: '100%' }}>
      <Box>
        {places.length > 0 ? (
          <Box sx={{ mt: 1, mb: 1 }}>
            {places.map((el: ICircleStoreModel, index: number) => (
              <Chip
                sx={{
                  backgroundColor: '#000',
                  color: '#fff',
                  '& .MuiChip-deleteIcon': {
                    color: '#fff',
                    fontSize: 11,
                  },
                  '&:hover': {
                    backgroundColor: '#ffa737',
                    color: '#000',
                    '& .MuiChip-deleteIcon': {
                      color: '#000',
                      fontSize: 11,
                    },
                  },
                  borderRadius: '8px',
                  mr: 1,
                }}
                color="secondary"
                deleteIcon={<Clear sx={{ fontSize: 10 }} />}
                variant="outlined"
                key={index}
                label={el.address}
                onDelete={() => handleDelete(el, index)}
                onClick={() => handleClick(el)}
              />
            ))}
          </Box>
        ) : (
          <Box component="div" sx={{ mt: 1, mb: 1 }}>
            <Chip
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                borderRadius: '8px',
                borderColor: 'error.light',
                mr: 1,
                '& .MuiChip-icon': {
                  color: 'error.main',
                },
              }}
              variant="outlined"
              icon={<Warning />}
              label={t('googleMapError')}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
